
export const styles = theme => ({
  paperItemPlx: {
    transform: "scale(0.6)",
    opacity: 0,
  },
  paperItem: {
    padding: 5,
  },
  img: {
    width: "100%"
  }
});


export const item01Anim = ({viewHeight, screen}) => {
  console.log('oi: %o -- totaal: %o', {viewHeight, screen}, viewHeight * (screen + 0.5));
  return [
  {
    start: viewHeight * (screen - 0.5),
    end: viewHeight * (screen - 0.25),
    properties: [
      {
        startValue: 0.6,
        endValue: 1,
        property: "scale",
      },
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
    ],
  },
]
}


export const item02Anim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 0.5),
    end: viewHeight * (screen - 0.25),
    properties: [
      {
        startValue: 0.6,
        endValue: 1,
        property: "scale",
      },
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
    ],
  },
]);


export const item03Anim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 0.25),
    end: viewHeight * screen,
    properties: [
      {
        startValue: 0.6,
        endValue: 1,
        property: "scale",
      },
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
    ],
  },
]);


export const item04Anim = ({viewHeight, screen}) => ([
  {
    start: viewHeight * (screen - 0.25),
    end: viewHeight * screen,
    properties: [
      {
        startValue: 0.6,
        endValue: 1,
        property: "scale",
      },
      {
        startValue: 0,
        endValue: 1,
        property: "opacity",
      },
    ],
  },
]);

